import React from "react";

// Renders API snippets where matches are wrapped in ⟦ ⟧ as <mark> elements.
// Never uses innerHTML, so snippet text can't inject markup.
export default function SearchHighlight({ text }) {
  const parts = String(text || "").split(/(⟦[^⟧]*⟧)/g);
  return (
    <>
      {parts.map((p, i) =>
        p.startsWith("⟦") && p.endsWith("⟧") ? (
          <mark key={i}>{p.slice(1, -1)}</mark>
        ) : (
          <React.Fragment key={i}>{p}</React.Fragment>
        )
      )}
    </>
  );
}
